import { create } from 'zustand'

/** Which mission the stage shows. The Control Plane queue writes it; the page reads it. */
interface MissionSelectionState {
  selectedId: string | null
  select: (id: string | null) => void
}

export const useMissionSelection = create<MissionSelectionState>((set) => ({
  selectedId: null,
  select: (id) => set({ selectedId: id }),
}))
